import { definePresentationResponse } from "../presenter"

export interface LoginResponse {
  readonly username?: string | null
  readonly suppressPasswordManager?: boolean
}

export const loginResponse = definePresentationResponse<LoginResponse, boolean>({
  type: "Login",
})
